import { z } from 'zod'

import { DateStringSchema, type ZodInfer } from '@mntn-dev/utility-types'

import { PaymentStatusSchema } from '../payment/payment-status.ts'

export const PaymentLineItemSchema = z.object({
  description: z.string().min(1),
  createdTime: DateStringSchema,
  updatedTime: DateStringSchema.optional(),
  billingMethod: z.literal('tipalti'),
  unit: z.literal('USD'),
  amount: z.number(),
  status: PaymentStatusSchema,
  originalAmount: z.number(),
})

export type PaymentLineItem = ZodInfer<typeof PaymentLineItemSchema>
